var React = require('react');

function Movie (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"36","height":"36","key":0}),React.createElement("polygon",{"stroke":"#FFFFFF","strokeLinecap":"round","strokeLinejoin":"round","points":"15 14 15 22 21 18.02","key":1}),React.createElement("rect",{"width":"29","height":"19","x":"3.5","y":"8.5","stroke":"#FFFFFF","strokeLinecap":"round","strokeLinejoin":"round","rx":"1","key":2})]));
}

Movie.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = Movie;

Movie.default = Movie;



//////////////////
// WEBPACK FOOTER
// ./src/app/icons/movie.svg
// module id = 700
// module chunks = 0